import { render, staticRenderFns } from "./Adminshz.vue?vue&type=template&id=44de95b4&scoped=true&"
import script from "./Adminshz.vue?vue&type=script&lang=js&"
export * from "./Adminshz.vue?vue&type=script&lang=js&"
import style0 from "./Adminshz.vue?vue&type=style&index=0&id=44de95b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44de95b4",
  null
  
)

export default component.exports